import { includes, isObject } from 'lodash';
import { NetworkError } from '../errors';

function jsonErrorMessage(body: any) {
  if (!body.error) {
    return undefined;
  }
  let message = body.error;
  if (body.details) {
    message += `; ${body.details}`;
  }
  return message;
}

export function checkResponseError(response: Response) {
  const allowedStatuses = [400, 401, 403];
  if (!response.ok && !includes(allowedStatuses, response.status)) {
    throw new NetworkError(`Unexpected status ${response.status} from ${response.url}.`);
  }
}

/**
 *  There is not a consistent format for error messages, this tries to figure
 *  out a structured error message (based on known formats), but falls back to
 *  returning the body of the response.
 *
 * @param response
 * @param responseBody
 */
export function coerceResponseErrorMessage(response: Response, responseBody: string) {
  let message = responseBody;
  try {
    const json = JSON.parse(responseBody);
    if (isObject(json)) {
      message = jsonErrorMessage(json);
    }
  } catch (err) {
    // ignore (presumably it was not json)
  }
  return `${response.url} [${response.status}] - ${message}`;
}
